import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";
import { api } from "../lib/api";

const FIELDS = [
  ["per_trade_pct", "Per trade (% of equity)"],
  ["exposure_pct", "Max deployed exposure (% of equity)"],
  ["options_exposure_pct", "Options max exposure (% of equity)"],
  ["daily_loss_pct", "Daily-loss halt (% of equity)"],
];

export const CapitalLimits = () => {
  const [v, setV] = useState({});
  const [bounds, setBounds] = useState({});
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get("/nexus/limits").then((r) => { setV(r.data.limits); setBounds(r.data.bounds); }).catch(() => {});
  }, []);
  const save = async () => {
    setBusy(true);
    try {
      const r = await api.post("/nexus/limits", Object.fromEntries(FIELDS.map(([k]) => [k, Number(v[k])])));
      setV(r.data.limits);
      toast.success("Limits saved — applied on the next sweep");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not save limits");
    } finally { setBusy(false); }
  };
  return (
    <div className="nx-glass rounded-2xl p-5 space-y-3" data-testid="capital-limits-card">
      <div className="flex items-center gap-2">
        <ShieldCheck className="w-4 h-4 text-emerald-300" />
        <span className="nx-orbitron text-xs tracking-[0.25em] font-bold text-emerald-300">CAPITAL LIMITS · OWNER ONLY</span>
      </div>
      <div className="grid grid-cols-3 gap-3">
        {FIELDS.map(([k, label]) => (
          <label key={k} className="block">
            <span className="text-[11px] text-cyan-200/60">{label}</span>
            <input type="number" step="0.5" min={bounds[k]?.[0]} max={bounds[k]?.[1]} value={v[k] ?? ""} onChange={(e) => setV({ ...v, [k]: e.target.value })}
              className="mt-1 w-full rounded-lg bg-[#0b1220] border border-white/10 px-3 py-2 text-cyan-50 text-sm" data-testid={`limits-${k}`} />
            {bounds[k] && <span className="text-[10px] text-cyan-200/30">{bounds[k][0]}–{bounds[k][1]}%</span>}
          </label>
        ))}
      </div>
      <div className="flex items-center justify-between">
        <p className="text-[11px] text-cyan-200/40">Agents can't change these. The $ per-trade and daily caps above still apply too.</p>
        <button onClick={save} disabled={busy} data-testid="limits-save-btn"
          className="px-3 py-1.5 rounded-lg bg-emerald-500/20 hover:bg-emerald-500/30 text-emerald-200 text-xs font-bold disabled:opacity-50">
          {busy ? "Saving…" : "Save limits"}
        </button>
      </div>
    </div>
  );
};
